import { all } from "redux-saga/effects";
import { dotXetHocVuSaga } from "./dotXetHocVuSaga";
import { dotXetHocVuPhamViSaga } from "./dotXetHocVuPhamViSaga";
import { xetHocVuSaga } from "./xetHocVuSaga";
import { dotXetHocVuPhamViSinhVienSaga } from "./dotXetHocVuPhamViSinhVienSaga";
import { quyetDinhHocVuSaga } from "./quyetDinhHocVuSaga";

export default function* xetHocVuSagaWrapper() {
  yield all([
    dotXetHocVuSaga(),
    dotXetHocVuPhamViSaga(),
    xetHocVuSaga(),
    dotXetHocVuPhamViSinhVienSaga(),
    quyetDinhHocVuSaga(),
  ]);
}
